module.exports = __webpack_public_path__ + "img/ic_services_bikerental.9306267d.svg";